var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntercom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V16H16V0H0ZM1.45455 1.45455H14.5455V14.5455H1.45455V1.45455ZM8.00142 2.90909C7.76997 2.90909 7.53835 3.06277 7.53835 3.36932V10.0724C7.53835 10.6855 8.46449 10.6855 8.46449 10.0724V3.36932C8.46449 3.06277 8.23288 2.90909 8.00142 2.90909ZM5.68892 3.14063C5.45747 3.14063 5.22585 3.29431 5.22585 3.60085V9.77699C5.22585 10.3901 6.15057 10.3901 6.15057 9.77699V3.60085C6.15057 3.29431 5.92038 3.14063 5.68892 3.14063ZM10.3111 3.14063C10.0796 3.14063 9.84801 3.29431 9.84801 3.60085V9.77699C9.84801 10.3901 10.7741 10.3901 10.7741 9.77699V3.60085C10.7741 3.29431 10.5425 3.14063 10.3111 3.14063ZM3.375 4.06676C3.14355 4.06676 2.91335 4.22044 2.91335 4.52699V8.68466C2.91335 9.29775 3.83807 9.29775 3.83807 8.68466V4.52699C3.83807 4.22044 3.60645 4.06676 3.375 4.06676ZM12.6236 4.06676C12.3921 4.06676 12.1605 4.22044 12.1605 4.52699V8.68466C12.1605 9.29775 13.0866 9.29775 13.0866 8.68466V4.52699C13.0866 4.22044 12.855 4.06676 12.6236 4.06676ZM12.6776 10.7628C12.5635 10.7468 12.4393 10.7766 12.3239 10.8764C10.3675 12.5455 5.71756 12.5884 3.67756 10.8764C3.21283 10.4801 2.61198 11.1832 3.0767 11.5795C5.4418 13.6043 10.6709 13.5301 12.9247 11.5795C13.2711 11.2801 13.0197 10.8106 12.6776 10.7628Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercom);
export default __webpack_public_path__ + "static/media/intercom.496a1a16385df284a4b2e48a4ed0b652.svg";
export { ForwardRef as ReactComponent };